import { AVALIABLE_GAME_SPEEDS } from '../constants';

/**
 * Service to handle state of the client models by using localStorage
 */
let defaultUserState = {
  params: {
    gameSettings: { blocks: true, language: 'python' },
    volume: 10,
    music: 10,
    sound: '01_Desert_Night',
    showWelcomeMessage: true,
    skipTutorial: false,
    gameSpeed: AVALIABLE_GAME_SPEEDS.NORMAL
  }
};

/**
 * @class StateService
 * It mostly interacts with Store e.g: sessionStorage / localStorage
 *
 */
class StateService {
  constructor() {
    // create default UserState
    this.saveUserState(defaultUserState);

    /**
     * With the removal of solution functions from StateService,
     * we need to more also these 3 lines ahead.
     */
    Store.remove('Solution');
    Store.remove('Solution:next');
    Store.remove('CurrentNextPage');
  }

  removeUserState() {
    Store.remove('UserState');
  }

  saveUserState(userState) {
    if (userState) {
      Store.set('UserState', JSON.stringify(userState));
    }
  }

  hasUserState() {
    return Store.has('UserState');
  }

  getUserState() {
    if (this.hasUserState()) {
      return JSON.parse(Store.get('UserState'));
    }

    this.saveUserState(defaultUserState);
    return defaultUserState;
  }

  removeTutorialState() {
    Store.remove('TutorialState');
  }

  saveTutorialState(tutorialState) {
    if (tutorialState) {
      Store.set('TutorialState', JSON.stringify(tutorialState));
    }
  }

  hasTutorialState() {
    return Store.has('TutorialState');
  }

  getTutorialState() {
    if (this.hasTutorialState()) {
      let tutorialState = JSON.parse(Store.get('TutorialState'));
      if (tutorialState.params) {
        tutorialState.params = JSON.parse(tutorialState.params);
      }
      return tutorialState;
    }
  }
}

export default new StateService();
